import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { Info } from '@ui/components/icons';
import { TextTooltip } from '@ui/components/TextTooltip';
import {
  calculateSpreadPercentage,
  useSpreadPercentage,
} from '@ui/features/Spread/useSpreadPercentage';
import { Order } from '@ui/hooks/trade/useTradeOrders/types';
import { useTradePairInfosByPairBase } from '@ui/hooks/trade/useTradePairInfos';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';
import { Icon } from '@ui/lib/park/ui/icon';
import { Text } from '@ui/lib/park/ui/text';
import { Trans, useTranslation } from 'next-i18next';
import { css } from 'styled-system/css';
import { HStack, VStack } from 'styled-system/jsx';
import { SystemStyleObject } from 'styled-system/types';

import { formatSlippage } from '../../utils/formatSlippage';

export const LimitOrderAt = ({
  order,
  labelStyle,
  valueStyle,
}: {
  order: Order;
  labelStyle: SystemStyleObject;
  valueStyle: SystemStyleObject;
}) => {
  const { t } = useTranslation();
  const priceDisplayDecimals = useTokenDisplayDecimals(
    order?.pair.baseSymbol,
    order?.pair.priceDisplayDecimals,
  );

  const pairInfo = useTradePairInfosByPairBase(order.pair.address);

  const spreadPercentageInfo = useSpreadPercentage({
    tradePair: pairInfo,
    positionSize: order.getSizeUsd(order.triggerPrice),
    pairPrice: order.triggerPrice,
  });

  return (
    <HStack alignItems="center" gap="0">
      <HStack gap="1" mr="2px">
        {/* <Text css={labelStyle}>{t('common.Limit Order at')}</Text> */}
        <AmountUsd
          css={valueStyle}
          value={order.triggerPrice}
          opts={{
            displayDecimals: priceDisplayDecimals,
          }}
          data-cy="TriggerPrice"
          data-cy-value={order.triggerPrice}
        />
      </HStack>
      {/* <TextTooltip
        content={
          <VStack alignItems="flex-start">
            <Text textStyle="text.small">
              Your order will be executed with ±Spread as Trigger Price
            </Text>
            <Text textStyle="text.xsmall" color="greyWhite.lightGrey3">
              {t('common.{slippagePercentage} spread applies', {
                slippagePercentage: formatSlippage(
                  calculateSpreadPercentage({
                    isClosePrice: false,
                    spreadPercentageInfo,
                    isLong: order.isLong,
                  }),
                ),
              })}
            </Text>
          </VStack>
        }
        contentCss={css.raw({
          maxW: '250px',
        })}
        triggerCss={css.raw({
          textDecoration: 'none',
        })}
      >
        <HStack>
          <Icon boxSize="3">
            <Info />
          </Icon>
        </HStack>
      </TextTooltip> */}
    </HStack>
  );
};
